export default __webpack_public_path__ + "static/media/photo--sm--hockey4.3ddc20be.jpg";